<template>
  <div class="item-overflow-actions">
    <v-menu
      v-if="itemOverflowActions"
      ref="itemOverflow"
      v-on-clickaway="clickawayFromMenu"
      tile
      left
      offset-y
      allow-overflow
      close-on-click
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :data-cy="(item.borrowerTaskName || item.name || item.full_name ) + '-3-dot-btn'"
          icon
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>$snMenuDotsHorizontalSolid</v-icon>
        </v-btn>
      </template>

      <v-list class="item-overflow-actions--item-list overflow-y-auto">
        <div
          v-for="action in itemOverflowActions"
          :key="action.key"
          :data-cy="action.text + '-action'"
        >
          <v-list-item
            link
            @click="$emit('overflow-action', { itemId: item[itemKey], action })"
          >
            <v-list-item-icon v-if="action.icon">
              <v-icon>{{ action.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-title>
              {{ action.text }}
            </v-list-item-title>
          </v-list-item>

          <v-divider
            v-if="action.divider"
          />
        </div>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'SnTableItemOverflowActions',
  mixins: [clickaway],
  props: {
    item: {
      type: Object,
      required: true
    },
    itemKey: {
      type: String,
      required: false,
      default: 'id'
    },
    itemOverflowActions: {
      type: Array,
      required: true
    }
  },
  methods: {
    clickawayFromMenu () {
      if (this.$refs.itemOverflow.isActive) {
        this.$refs.itemOverflow.isActive = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item-overflow-actions {
  &--item-list {
    max-height: 500px;
  }
}
</style>
